import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/sharp-light-svg-icons/faEnvelope';
import { faPhone } from '@fortawesome/sharp-light-svg-icons/faPhone';
import { faTimer } from '@fortawesome/sharp-light-svg-icons/faTimer';

import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Text, TextType } from 'ui-components/components/text';

import { SelectEnrollmentButton } from './select-enrollment-button';
import { MANAGEMENT_TYPES } from '../../../../../../global/step-up-authentication/constants';
import { messages } from '../messages';
import style from './add-mfa-enrollment.module.less';

/** @typedef {import('../../../../../../global/step-up-authentication/api').Auth0ManagementMfaType} Auth0ManagementMfaType */

/**
 * @type {Auth0ManagementMfaType[]}
 */
const VerificationMethods = [MANAGEMENT_TYPES.EMAIL, MANAGEMENT_TYPES.PHONE, MANAGEMENT_TYPES.TOTP];

const DisplayForMethod = {
  [MANAGEMENT_TYPES.EMAIL]: {
    Icon: <FontAwesomeIcon icon={faEnvelope} />,
    name: messages.emailName,
  },
  [MANAGEMENT_TYPES.PHONE]: {
    Icon: <FontAwesomeIcon icon={faPhone} />,
    name: messages.phoneName,
  },
  [MANAGEMENT_TYPES.TOTP]: {
    Icon: <FontAwesomeIcon icon={faTimer} />,
    name: messages.authenticatorAppName,
  },
};

/**
 * @param {object} props
 * @param {() => void} props.onCancel
 * @param {(arg0: string) => void} props.onContinue
 * @returns {React.JSX.Element}
 */
export const SelectEnrollmentType = ({ onCancel, onContinue }) => {
  const [selected, setSelected] = useState(/** @type {Auth0ManagementMfaType} */ (null));

  const onClickContinue = useCallback(() => {
    onContinue(selected);
  }, [onContinue, selected]);

  return (
    <>
      <ModalBody className={style['add-enrollment-modal-content']}>
        <FlexColumn gap={Gap.Space16}>
          <Text textType={TextType.H3} value={messages.selectEnrollmentTypeHeader} />
          <Text textType={TextType.Paragraph} value={messages.selectEnrollmentTypeSubheader} />
          <FlexColumn className={style['verification-methods-section']} gap={Gap.Space4}>
            <Text textType={TextType.Label} value={messages.verificationMethods} />
            <FlexRow className={style['verification-methods']} gap={Gap.Space8}>
              {VerificationMethods.map((method) => {
                const { Icon, name } = DisplayForMethod[method];
                return (
                  <SelectEnrollmentButton
                    key={method}
                    Icon={Icon}
                    isSelected={method === selected}
                    name={name}
                    onClick={() => setSelected(method)}
                  />
                );
              })}
            </FlexRow>
          </FlexColumn>
        </FlexColumn>
      </ModalBody>
      <ModalFooter>
        <FlexRow className={style.footer} gap={Gap.Space16}>
          <Button onClick={onCancel} theme='tertiary'>
            <FormattedMessage {...messages.cancelButton} />
          </Button>
          <Button onClick={onClickContinue} theme='primary'>
            <FormattedMessage {...messages.continueButton} />
          </Button>
        </FlexRow>
      </ModalFooter>
    </>
  );
};
